import "regenerator-runtime/runtime";
import "../funds/FileSaver.min.js";
import Highcharts from 'highcharts';
//import "../../../../js/jquery.floatThead.min.js";
var moment = require('moment');
require('floatthead');

window.commonFundUtils = {
    //Popover disclosure
    popoverDisclosure: "Please see Morningstar disclosures below",
    //sort icon markup
    moreInfoIconMarkup:
        `<span class="more-info-icon-svg"><svg width="15px" height="15px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Fund-Explorer" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Utility_Screener_Default" transform="translate(-353.000000, -570.000000)"><g id="More-Info-Icon" transform="translate(353.000000, 570.000000)"><circle id="Oval" stroke="#17468F" stroke-width="1.25" cx="7.5" cy="7.5" r="6.875"></circle><path d="M7.50549316,5.35949707 C8.27087402,5.35949707 8.65356445,5.04455566 8.65356445,4.41467285 C8.65356445,4.09973145 8.56201172,3.86169434 8.37890625,3.70056152 C8.19580078,3.53942871 7.90466309,3.4588623 7.50549316,3.4588623 C7.10632324,3.4588623 6.8170166,3.53759766 6.63757324,3.69506836 C6.45812988,3.85253906 6.3684082,4.09240723 6.3684082,4.41467285 C6.3684082,5.04455566 6.74743652,5.35949707 7.50549316,5.35949707 Z M8.57116699,11.9637451 L8.57116699,5.96374512 L6.42333984,5.96374512 L6.42333984,11.9637451 L8.57116699,11.9637451 Z" id="i" fill="#17468F" fill-rule="nonzero" transform="translate(7.510986, 7.711304) scale(-1, 1) translate(-7.510986, -7.711304) "></path></g></g></g></svg></span>`,
    //sort icon markup
    sortIconMarkup:
        '<div class="table-thead-icon d-inline"> <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="exchange-v" class="svg-inline--fa fa-exchange-v fa-w-19 fa-sm icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 12">  <path fill="currentColor" d="M10.25 11.25a.5.5 0 00.5.5.5.5 0 00.5-.5V.75a.5.5 0 00-.5-.5.5.5 0 00-.5.5zm-2.7-7.78a.5.5 0 00.15.33.5.5 0 00.7 0l2.35-2.34L13.1 3.8a.5.5 0 00.7 0 .5.5 0 000-.7L11.1.4a.5.5 0 00-.7 0L7.7 3.1a.5.5 0 00-.15.37zm-4.8 7.78a.5.5 0 00.5.5.5.5 0 00.5-.5V.75a.5.5 0 00-.5-.5.5.5 0 00-.5.5zM.05 8.57a.5.5 0 00.15.33l2.7 2.7a.5.5 0 00.7 0l2.7-2.7a.5.5 0 000-.7.5.5 0 00-.7 0l-2.35 2.34L.9 8.2a.5.5 0 00-.7 0 .5.5 0 00-.15.37z"></path></svg></div>',
    //used for sending the API call
    getData: async (blockId, endpoint) => {
        try {
            const data = await $.get(endpoint + '?blockId=' + blockId)
            return data
        }
        catch (e) {
            console.error(e)
        }
    },
    //used for sorting data within each group
    sortDataArray: (dataSet, wrapperDiv) => {
        var sortedData = {}
        $.each(dataSet.Groups, function (index) {
            sortedData[index] = commonFundUtils.sortData(this, wrapperDiv)
        })
        return sortedData;
    },
    //sort items within the group
    sortData: (dataSet, wrapperDiv) => {
        var sortTitle = wrapperDiv.attr("data-sorttitle")
        var sortType = wrapperDiv.attr("data-sorttype")
        var newArray = dataSet.sort((a, b) => {
            if (a[sortTitle] == null || b[sortTitle] == null) {
                return 0
            }
            let la, lb;
            //if string the data is converted to lowercase for comparison
            if (isNaN(a[sortTitle]) && isNaN(b[sortTitle])) {
                la = a[sortTitle].toLowerCase(), lb = b[sortTitle].toLowerCase();
            } else {
                la = Number(a[sortTitle]), lb = Number(b[sortTitle]);
            }

            if (sortType == "asc") {
                if (la < lb) return -1;
                if (la > lb) return 1;
                return 0;
            } else {
                if (la > lb) return -1;
                if (la < lb) return 1;
                return 0;
            }
        })
        return newArray
    },
    //draw each group item in a row
    drawItemsInGroup: (dataSet, cellClassesArray, headerArray, enableDecimals, isExcel) => {
        //var borderStyles = (isExcel) ? "border: 1px solid #000; border-collapse: collapse;" : "";
        var tableRow = '';
        $.each(dataSet, function () {
            tableRow += '<tr>'
            var item = this;
            var internalCount = 0;
            //loop through each group item attributes (items in the table row)
            $.each(headerArray, function (i) {
                var headerArrayItem = this
                //added 2 decimal places if enableDecimals is true
                var currentItem = (enableDecimals && !isNaN(item[this])) ? item[this].toFixed(2) : item[this];
                //if it's a number converted to string and added the comma after 3 digits
                var currentItemNew = (!isNaN(item[this]) && currentItem !== null) ? currentItem.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : currentItem;
                //if item is null, -- is added instead
                var modifiedItem = (currentItem === null) ? "--" : currentItemNew;
                //item link
                var linkVal = ("FormattedLink" in item) && isNaN(currentItem) && item.FormattedLink !== null ? item.FormattedLink : "#";

                //check if the item consist of a Link
                if (isNaN(currentItem) && ("FormattedLink" in item)) {
                    //check if the current index is 1 and has a morningstar rating and is not for excel downloading
                    if (i == 1 && item.CardData && item.CardData.MorningStarRating != null && !isExcel) {
                        //check if there are footnotes
                        if (item.Footnotes && item.Footnotes.filter(e => e.ColumnName === this).length > 0 && modifiedItem !== "--") {
                            //filter the footnote object relevant for this column
                            var footerNote = item.Footnotes.filter(e => e.ColumnName === this)
                            tableRow += `<td class="${cellClassesArray[internalCount]}"><a class="fund-explorer-table-tooltip-item" href="${linkVal}"> ${modifiedItem} <sup> ${footerNote[0].Symbol}</sup> ${commonFundUtils.moreInfoIconMarkup}</a>${commonFundUtils.drawPopoverCard(item.CardData)}</td>`
                        } else {
                            tableRow += `<td class="${cellClassesArray[internalCount]}"><a class="fund-explorer-table-tooltip-item" href="${linkVal}"> ${modifiedItem} ${commonFundUtils.moreInfoIconMarkup}</a>${commonFundUtils.drawPopoverCard(item.CardData)}</td>`
                        }
                    }
                    //if still this is a link and i != 1 and no morningstar
                    else {
                        if (item.Footnotes && item.Footnotes.filter(e => e.ColumnName === this).length > 0 && modifiedItem !== "--" && !isExcel) {
                            var footerNote = item.Footnotes.filter(e => e.ColumnName === this)
                            tableRow += `<td class="${cellClassesArray[internalCount]}"><a href="${linkVal}"> ${modifiedItem} <sup> ${footerNote[0].Symbol}</sup></a></td>`
                        } else {
                            tableRow += `<td class="${cellClassesArray[internalCount]}"><a href="${linkVal}"> ${modifiedItem}</a></td>`
                        }
                    }
                }
                //if the item is not a link
                else {
                    if (item.Footnotes && item.Footnotes.filter(e => e.ColumnName === this).length > 0 && modifiedItem !== "--" && !isExcel) {
                        var footerNote = item.Footnotes.filter(e => e.ColumnName === this)
                        tableRow += `<td class="${cellClassesArray[internalCount]}">${modifiedItem}<sup> ${footerNote[0].Symbol}</sup></td>`
                    } else {
                        tableRow += '<td class="' + cellClassesArray[internalCount] + '">' + modifiedItem + '</td>'
                    }
                }
                internalCount++;
            })
            tableRow += '</tr>'
        })
        return tableRow;
    },
    //used to change attributes on heading click on the tables
    changeDivAttributes: (element, wrapperDiv) => {
        var title = $(element).attr("id");
        if (wrapperDiv.attr("data-sorttitle") == title) {
            wrapperDiv.attr("data-sorttype") === "desc" ?
                wrapperDiv.attr("data-sorttype", "asc") :
                wrapperDiv.attr("data-sorttype", "desc")
        } else {
            wrapperDiv.attr("data-sorttitle", title);
            wrapperDiv.attr("data-sorttype", "asc");
        }
    },
    //used for formatting the date when received in "/Date(1360521000000)/" format
    dateFormatter: dateString => {
        if (dateString != null) {
            var mySubString = dateString.substring(
                dateString.indexOf("(") + 1,
                dateString.lastIndexOf(")")
            );
            return moment(parseInt(mySubString)).format("L");
        }
    },
    //used for the sticky headers on the tables and called for each table by the table wrapper ID | 41px is added to display the header below the sticky nav
    floatThread: function (blockId) {
        var $table = $('#' + blockId + ' .fund-listing-table.table-desktop');
        var top = $table.data("top-margin") + 41 || 95 + 41;
        $table.floatThead({
            top: top,
            zIndex: 1,
            responsiveContainer: function ($table) {
                return $table.parent();
            },
            getSizingRow: function ($table) {
                return $table.find('tbody tr:not(.grouping):visible:first>*');
            },
            debug: true,
        });
    },
    /**
     * On mobile the title and ticker is mainly taken as the header. This block is used to draw it
     * @param {any} item
     * @param {any} headerColumns
     * @param {any} headerArray
     */
    drawMobileHeader: (item, headerColumns, headerArray) => {
        var linkVal = (("FormattedLink" in item) && item.FormattedLink !== null) ? item.FormattedLink : "#";
        var mobileHeader = '<div class="fund-explorer-table__card-header row">';
        
        if (headerColumns == 1) {
            //checked for Link or Formatted link is available in the Object
            if (("Link" in item) || ("FormattedLink" in item)) {
                mobileHeader += `<div class="fund-explorer-table__card-ticker col-12"><a href="${linkVal}">${item[headerArray[0]]}</a></div>`
            } else {
                mobileHeader += `<div class="fund-explorer-table__card-ticker col-12"><span>${item[headerArray[0]]}</span></div>`
            }
        } else if (headerColumns == 2) {
            var ColumnOneNote, ColumnTwoNote;
            if (item.Footnotes && item.Footnotes.length > 0) {
                ColumnOneNote = item.Footnotes.filter(e => e.ColumnName === headerArray[0]) ?? []
                ColumnTwoNote = item.Footnotes.filter(e => e.ColumnName === headerArray[1]) ?? []
                
            }
            //checked for footnotes available for the item
            if (item.Footnotes && item.Footnotes.length > 0 && (ColumnOneNote.length > 0 || ColumnTwoNote.length > 0)) {
                if (("Link" in item) || ("FormattedLink" in item)) {
                    mobileHeader += `<div class="fund-explorer-table__card-ticker col-2"><a href="${linkVal}">${item[headerArray[0]]}${(ColumnOneNote.length > 0) ? "<sup>" + ColumnOneNote[0].Symbol + "</sup>" : ""}</a></div>`
                    mobileHeader += `<div class="fund-explorer-table__card-ticker col-10"><a href="${linkVal}">${item[headerArray[1]]}${(ColumnTwoNote.length > 0) ? "<sup>" + ColumnOneNote[0].Symbol + "</sup>" : ""}</a></div>`
                } else {
                    mobileHeader += `<div class="fund-explorer-table__card-ticker col-2"><span>${item[headerArray[0]]}${(ColumnOneNote.length > 0) ? "<sup>" + ColumnOneNote[0].Symbol + "</sup>" : ""}</span></div>`
                    mobileHeader += `<div class="fund-explorer-table__card-ticker col-10"><span>${item[headerArray[1]]}${(ColumnTwoNote.length > 0) ? "<sup>" + ColumnTwoNote[0].Symbol + "</sup>" : ""} </span></div>`
                }
            } else {
                if (("Link" in item) || ("FormattedLink" in item)) {
                    mobileHeader += `<div class="fund-explorer-table__card-ticker col-2"><a href="${linkVal}">${item[headerArray[0]]}</a></div>`
                    mobileHeader += `<div class="fund-explorer-table__card-ticker col-10"><a href="${linkVal}">${item[headerArray[1]]}</a></div>`
                } else {
                    mobileHeader += `<div class="fund-explorer-table__card-ticker col-2"><span>${item[headerArray[0]]}</span></div>`
                    mobileHeader += `<div class="fund-explorer-table__card-ticker col-10"><span>${item[headerArray[1]]}</span></div>`
                }
            }
            
        }
        mobileHeader += '</div>'
        return mobileHeader;
    },
    /**
     * 
     * @param {any} item - row item
     * @param {any} startColumn - start column of the header array
     * @param {any} endColumn - end column of the header array
     * @param {any} headerArray - header array to be looped to get value of each item
     */
    drawMobileItems: (item, startColumn, endColumn, headerArray, titleArray, enableDecimals) => {
        var localCount = startColumn
        var mobileItem = '';
        var slicedArray = headerArray.slice(startColumn, endColumn);
        $.each(slicedArray, function () {
            //convert to a date
            var currentItem = (typeof (item[this]) === "string" && item[this].includes("Date")) ? commonFundUtils.dateFormatter(item[this]) : item[this];
            //if number, make it a string with commas

            //added 2 decimal places if enableDecimals is true
            var itemWithDecimals = (enableDecimals && !isNaN(item[this])) ? item[this].toFixed(2) : currentItem;
            //if it's a number converted to string and added the comma after 3 digits
            var currentItemNew = (!isNaN(item[this]) && itemWithDecimals !== null) ? itemWithDecimals.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : currentItem;
            //if item is null, -- is added instead
            var modifiedItem = (currentItem === null) ? "--" : currentItemNew;

            //var currentItemNew = (!isNaN(item[this]) && currentItem !== null) ? currentItem.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : currentItem;

            //check if footnotes are available for the item
            if (item.Footnotes && item.Footnotes.filter(e => e.ColumnName === this).length !== 0 && modifiedItem !== "--") {
                var footerNote = item.Footnotes.filter(e => e.ColumnName === this)
                mobileItem += `<div class="fund-explorer-table__card-body col-md-3 col-6"><div class="fund-explorer-table__card-column ">${titleArray[localCount]}</div><div class="fund-explorer-table__card-data" >${modifiedItem} <sup> ${footerNote[0].Symbol} </sup></div></div>`;
            } else {
                mobileItem += `<div class=" fund-explorer-table__card-body col-md-3 col-6"><div class="fund-explorer-table__card-column ">${titleArray[localCount]}</div><div class="fund-explorer-table__card-data" >${modifiedItem}</div></div>`;
            }


            //mobileItem += '<div class=" fund-explorer-table__card-body col-md-3 col-6">'
            //    + '<div class="fund-explorer-table__card-column ">' + titleArray[localCount] + '</div><div class="fund-explorer-table__card-data" >' + modifiedItem + '</div></div>';
            localCount++;
        })
        return mobileItem;
    },
    /**
     * The common function used to draw the tables in desktop version
     * @param {any} mainWrapperId
     * @param {any} desktopWrapperId
     * @param {any} tableData
     * @param {any} drawHeaderFunction
     * @param {any} drawHeaderData
     */
    drawDesktopTable: (mainWrapperId, desktopWrapperId, tableData, drawHeaderFunction, drawHeaderData) => {
        var tableDetails = '';
        if ($('#' + mainWrapperId + ' h3').length == 0) {
            tableDetails += '<h3 class="pt-4 pb-2">' + tableData.Title + '</h3>';
            tableDetails += '<span class="fund-explorer-table__download-excel pb-2 excel-download d-inline-block" data-wrapperid ="' + desktopWrapperId + '"> Download Excel </span>';
        }
        if ($('#' + desktopWrapperId + '').length != 0) {
            $('#' + desktopWrapperId + '').remove()
        }
        tableDetails += '<div id="' + desktopWrapperId + '">'
        tableDetails += '<div class="tab-container d-lg-block d-none">';
        tableDetails += '<table class="table fund-listing-table table-desktop " border="0">';
        tableDetails += drawHeaderFunction(drawHeaderData);
        tableDetails += '</table>';
        if ($('#' + desktopWrapperId + ' .table-footer').length == 0 && tableData.AsOfDateText) {
            tableDetails += '<div class="table-footer peformance_footer mt-3"><strong>' + tableData.AsOfDateText + '</strong></div>';
        }
        if ($('#' + desktopWrapperId + ' .table-footer').length == 0 && tableData.FooterText) {
            tableDetails += '<div class="table-footer peformance_footer mt-3">' + tableData.FooterText + '</div>';
        }
        tableDetails += '</div></div>';
        $('#' + mainWrapperId + '').append(tableDetails);
    },
    /**Generate Report for the table */
    downloadExcelReport: (wrapperId) => {

        //Replace the Apostrophe
        $(".excel-table td").each((i, e) => {
            const text = $(e).html();
            $(e).html(text.replace("’", '&apos;'))
        })
        let tab = $('#excelDrawArea .excel-table');

        var tab_text = tab[0].outerHTML;

        tab_text = tab_text.replace(/<A[^>]*>|<\/A>/g, "");//remove if u want links in your table
        tab_text = tab_text.replace(/<img[^>]*>/gi, ""); // remove if u want images in your table
        tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi, ""); // reomves input params

        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        var blob = new Blob([tab_text],
            {
                type: "application/vnd.ms-excel;charset=utf-8"
            });

        return saveAs(blob, wrapperId + ".xls");

    },
    generateExcelTable: (wrapperId, drawExcelFunction) => {
        $('#' + wrapperId + ' span.excel-download').on("click", function () {
            var wrapperDiv = $(this).attr("data-wrapperid")
            drawExcelFunction(wrapperDiv)
        })
    },
    //to add the spinner to the tables
    spinner: {
        itemArray: [],
        init: function () {
            $("#veSpinnerContainer").append('<div id="loading"><div id="loadingcontent"><p id="loadingspinner"></p></div></div>');
            $("#veLoginSpinnerContainer").append('<div id="loginloading"><div id="loadingcontent"><p id="loadingspinner"></p></div></div>');
            //$('#viewport-wide-spinner').hide();
            commonFundUtils.spinner.theSpinner = commonFundUtils.spinner.load();
        },
        load: function () {
            var eventType = "blur";
            var id = "loading";

            //If want to change the text below the spinning div.
            //if (progressText != undefined) { $("#loadingspinner").html(progressText); }
            $('#loading').fadeIn();
            var opts = {
                lines: 12, // The number of lines to draw
                length: 7, // The length of each line
                width: 4, // The line thickness
                radius: 10, // The radius of the inner circle
                color: '#000', // #rgb or #rrggbb
                speed: 1, // Rounds per second
                trail: 60, // Afterglow percentage
                shadow: false, // Whether to render a shadow
                hwaccel: false // Whether to use hardware acceleration
            };
            var target = document.getElementById('loading');
            var spinner = new Spinner(opts).spin(target);

            return spinner;
        },
        hide: function (tableName) {
            commonFundUtils.spinner.itemArray = commonFundUtils.spinner.itemArray.filter(item => item != tableName)
            if (commonFundUtils.spinner.itemArray.length == 0) {
                $('#viewport-wide-spinner').hide();
            }

        },
        show: function (tableName) {
            if (commonFundUtils.spinner.itemArray.length == 0) {
                $('#viewport-wide-spinner').show();
            }
            commonFundUtils.spinner.itemArray.push(tableName)

        }
    },
    initColumnHighchartWidget: () => {
        $(".column_chart_container").each(function (i, chartContainer) {
            var uniqueName = "column_chart" + i;
            var xAxesSpace = -10;
            $(chartContainer).attr("id", uniqueName);
            var decimalSeparator = $(chartContainer).data("decimal-separator") || ".";

            var masColor = [];
            $(chartContainer).parent().find(".details .dia_color").each(function () {
                masColor.push($(this).css("color"));
            });
            if (masColor.length === 0) return;

            //used to create the data array
            var masData = [];
            //used to create the categories array
            var masCategories = [];
            $(chartContainer).parent().find(".details .data").each(function () {
                var col1 = $(this).find(".col1").text();
                var col2 = $(this).find(".col2").text().replace(',', '.');
                var flo = parseFloat(col2);
                if (flo != '') {
                    masData.push(flo);
                    masCategories.push(col1);
                }
                if (flo < 0.0001) {
                    xAxesSpace = 10;
                }
            });
            if (masData.length === 0) return;

            Highcharts.setOptions({ colors: masColor });

            Highcharts.chart(uniqueName, {
                chart: {
                    type: 'column'
                },
                credits: false,
                title: { text: '' },
                legend: { enabled: false },
                xAxis: {
                    categories: masCategories,
                    crosshair: false,
                    labels: {
                        rotation: 270,
                        style: {
                            fontWeight: 'normal',
                            fontSize: '12px',
                            fontFamily: 'Verdana, sans-serif',
                            textOutline: 0
                        },
                    }
                },
                yAxis: {
                    min: 0,
                    visible: false,
                    //x: xAxesSpace,
                },
                plotOptions: {
                    series: {
                        pointPadding: 0.1,
                        groupPadding: 0,
                        borderWidth: 0,
                        dataLabels: {
                            style: {
                                fontWeight: 'normal',
                                fontSize: '12px',
                                fontFamily: 'Verdana, sans-serif',
                                textOutline: 0
                            },
                        },
                    }
                },
                tooltip: {
                    formatter: function () {
                        return '<b>' + this.point.category + '</b>:' + String(this.y).replace(".", decimalSeparator) + '%';
                    }
                },
                series: [{
                    pointPadding: 0.1,
                    data: masData,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y:.1f}' // one decimal
                    }

                }]
            })
        });
    },
    //highchart code
    initMaturityLineHighchartWidget: () => {
        $(".maturity_line_chart_container").each(function (i, chartContainer) {
            var uniqueName = "maturity_line_chart" + i;
            $(chartContainer).attr("id", uniqueName);
            var decimalSeparator = $(chartContainer).data("decimal-separator") || ".";

            var masColor = [];
            $(chartContainer).parent().find(".details .dia_color").each(function () {
                masColor.push($(this).css("color"));
            });
            if (masColor.length === 0) return;

            var masData = [];
            $(chartContainer).parent().find(".details .data").each(function () {
                var seriesName = $(this).find(".seriesName").text();
                var xAxis = $(this).find(".col1 > string").toArray();
                var yAxis = $(this).find(".col2 > number").toArray();

                if (yAxis.length !== xAxis.length) {
                    return;
                }

                var seriesData = [];
                for (var j = 0; j < yAxis.length; j++) {
                    var xValue = parseFloat($(xAxis[j]).text().replace(',', '.'));
                    var yValue = parseFloat($(yAxis[j]).text().replace(',', '.'));

                    seriesData.push(
                        [
                            xValue,
                            yValue
                        ]
                    );
                }

                masData.push({
                    name: seriesName,
                    data: seriesData,
                    marker: {
                        symbol: 'square'
                    }
                });
            });

            if (masData.length === 0) return;

            Highcharts.setOptions({ colors: masColor });

            Highcharts.chart(uniqueName, {
                chart: {
                    type: 'line',
                },
                credits: { enabled: false },
                title: { text: '' },

                yAxis: {
                    title: {
                        text: 'Yield (%)',
                        style: {
                            fontSize: '14px',
                        },
                    },
                    gridLineColor: '#ccd6eb',
                    gridLineDashStyle: 'ShortDot',
                    tickInterval: 1,
                    min: 0
                },
                xAxis: {
                    title: {
                        text: 'Maturity (Years)',
                        style: {
                            fontSize: '14px',
                        },
                    },
                    categories: [],
                    tickInterval: 1,
                },
                plotOptions: {
                    line: {
                        marker: { enabled: false },
                    }
                },
                responsive: {
                    rules: [
                        {
                            condition: {
                                maxWidth: 450
                            },
                            chartOptions: {
                                chart: {
                                    width: 330,
                                }
                            }
                        }
                    ]
                },
                tooltip: {
                    formatter: function () {
                        var pointName = this.point.series.name;
                        if (pointName.length > 20) { pointName = pointName.substring(0, 20) + ".."; }
                        return pointName + '<br/>' + '<b>' + this.x + '</b>: ' + String(this.y).replace(".", decimalSeparator) + '%';
                    }
                },
                //series: masData,
                series: masData,
                legend: {
                    symbolHeight: 12,
                    symbolRadius: 0,
                    squareSymbol: true,
                },
            });
        });
    },
    
    //underlined class function
    getUnderlinedClass: (wrapperId, columnId) => {
        let sortTitle = $('#' + wrapperId + '').attr("data-sorttitle");
        let classVal = (sortTitle === columnId) ? "underlined" : ""
        return classVal;
    },

    //draw the popover card
    drawPopoverCard: (cardData) => {
        if (typeof cardData != "object" || cardData === null) {
            console.error("Card Data not provided for" + cardId); return false;
        }

        if (cardData.MorningStarRating != "") {
            var morningstarMarkup =
                '<div class="d-flex mb-3"><div class="ml-1"> <div class="fund-explorer-block__rating-description">Overall Morningstar Rating</div> <div class="fund-explorer-block__rating-in-words">' +
                cardData.MorningStarRating +
                '</div> </div> </div>';
        } else {
            var morningstarMarkup = "";
        }
        return `<div class="fund-explorer-table-tooltip-content" id="" style="display:none"><div class="fund-explorer-block w-100"><h5 class="mb-0">${cardData.Ticker}</h5><div class="mb-2">${cardData.FundName}</div>${morningstarMarkup} <div class="d-flex"> <div class="fund-explorer-block__info-title">Asset Class</div> <div class="fund-explorer-block__info-description">${cardData.AssetClass}</div> </div> <div class="d-flex"> <div class="fund-explorer-block__info-title">Category</div> <div class="fund-explorer-block__info-description">${cardData.Category}</div> </div>${cardData.Description}<div class="fund-explorer-block__details mt-4 ">${commonFundUtils.popoverDisclosure}</div> </div> </div >`;
    },
    //initiate popover for the tables
    initiatePopover: () => {
        $('.yield-monitor .fund-explorer-table-tooltip-item').each(function (i, e) {
            const $ele = $(e),
                $popoverLink = $ele.next('.fund-explorer-table-tooltip-content'),
                popoverID = 'popoverid' + String(Math.random()).substr(2);
            $(this).attr('id', popoverID);
            $popoverLink.attr('id', ('po' + popoverID));
            $ele.popover({
                html: true,
                trigger: 'hover',
                content: function () {
                    const id = $(this).attr('id');
                    return $('#po' + id).html();
                },
                popperConfig: {
                    placement: 'right-start',
                },
            });
        });
    },     
}